// extracted by mini-css-extract-plugin
export default {"wrapper":"kS-z","availablePromoMessagesLabel":"lS-z","promoMessageList":"mS-z","promoMessage":"nS-z","appliedPromoMessage":"oS-z","promoMessageAmount":"pS-z"};